<!-- <p>create-cmms-case works!</p> -->

<app-dialog-header headerIcon="work" headerText="{{!editing ? 'Create New CMMS Case' : 'Edit CMMS Case'}}"
    (onCloseClick)="onCancelClick()"></app-dialog-header>
@if (asset) {
<div class="asset-details">
    <span>Asset Name:</span>
    <span>{{asset.Name}}</span>

    <span>Asset Description:</span>
    <span>{{asset.Description}}</span>

    <!-- @if (asset.EquipmentCode) { -->
    <span>Asset EQ:</span>
    <div>
        @if (asset.EquipmentCode && asset.EquipmentCode != "") { {{ asset.EquipmentCode}} }
        @else { {{ asset.Name }} }
    </div>

    <!-- } -->

    @if (asset.FunctionalLocation || asset.ParentFunctionalLocation) {
    <span>Asset FL:</span>
    <div>
        @if (asset.FunctionalLocation && asset.FunctionalLocation != "") { {{ asset.FunctionalLocation}} }
        @else { {{ asset.ParentFunctionalLocation }} }
    </div>
    }

    <!-- @if(parent){
    <span>Parent Location:</span>
    <span>{{parent.Name}}</span>
    @if (parent.FunctionalLocation) {
    <span>Parent FL:</span>
    <span>{{parent.FunctionalLocation}}</span>
    }
    } -->
    
</div>
@if (attachedToEvent && this.dialogData.caseFile) {
<div class="asset-details">
    <span>EventID:</span>
    <span>{{this.dialogData.caseFile.TriggerID}}</span>
    <span>Trigger Type:</span>
    <span>{{getTriggerTypeDesc(dialogData.caseFile.TriggerType)}}</span>
</div>
}
}
<!-- <br> -->
<form [formGroup]="dialogForm">
    <div mat-dialog-content style="width: 600px; max-width: 800px; padding: 1em;">
        @if (!attachedToEvent && this.dialogData.caseFile.TriggerType !=8 ) {
        <mat-form-field>
            <mat-label>Trigger Type</mat-label>
            <mat-select formControlName="TriggerType">
                @for (trigger of triggerTypes; track $index) {
                <mat-option [value]="trigger.TriggerType">{{trigger.Description}}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        }
        @if (Rules && Rules.length > 0){
        <mat-form-field>
            <mat-label>Disable Rules</mat-label>
            <mat-select formControlName="RuleList" multiple (selectionChange)="onSelectionChange($event)">
                <!-- Select All option -->
                <mat-option [value]="'__all__'">Select All</mat-option>
                @for (rule of Rules; track $index) {
                <mat-option [value]="rule.RuleID">{{ rule.RuleDescription }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        }
        <mat-form-field>
            <mat-label>Case Description</mat-label>
            <textarea matInput formControlName="Description" maxlength="1000"></textarea>
            <mat-hint align="end">{{ getCommentLength() }}/{{1000}}</mat-hint>
        </mat-form-field>
    </div>

    <div mat-dialog-actions>
        <button mat-button (click)="onDialogClose()" [disabled]="dialogForm.invalid || !dialogForm.dirty">Ok</button>
        @if (!attachedToEvent) {
        <button mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
        }
        @if (attachedToEvent && creatingCase) {
        <button mat-button (click)="onSkipClick()" cdkFocusInitial>Cancel</button>
        }
    </div>

</form>